export default __webpack_public_path__ + "static/SRUS BC420 - Especification Del Producto y Datos Técnicos-8a440e1ef11d884954cf5baf0d3d21f1.pdf";